module.exports = __webpack_public_path__ + "static/img/wzry-companyProducts6.792f5dec.png";